import { FormControl } from "@angular/forms";
import * as dayjs from 'dayjs';
import *as customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat)

export function dataValidator(control: FormControl) {
    if (control.value && control.value != '' && control.value != undefined) {    
        let format = control.value.indexOf('/') != -1?'DD/MM/YYYY': 'YYYY-MM-DD';
        if (!dayjs(control.value,format).isValid())
            return {
                data: true,
                mensagem: (campo: string) => `O campo <b>${campo}</b> não é uma data válida`
            }
    }

    return null;
}

